import type { CourseEntityChangeStatus } from "@repo/app-types/entities/course";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import type { VisibleInterviewSectionDefinition } from "../interviewSections/definitions/state.js";
import { getChangeStatusHighlightClasses } from "./changeStatusHighlight.js";
import { LessonItemDuration } from "./lessonItemDuration.js";
import { LessonItemIcon } from "./lessonItemIcon.js";
import { LessonItemTitle } from "./lessonItemTitle.js";

interface LessonItemSettingsContentProps {
  section: VisibleInterviewSectionDefinition | undefined;
  changeStatus?: CourseEntityChangeStatus;
}

/** Presentational component that renders the inside of a lesson cell in a course tree UI for settings. */
export const LessonItemSettingsContent: FC<LessonItemSettingsContentProps> = (
  props,
) => {
  return (
    <div
      className={twMerge(
        "flex min-w-0 items-center space-x-4 px-4 py-2",
        getChangeStatusHighlightClasses(props.changeStatus),
      )}
    >
      <LessonItemIcon type={props.section?.settings.type} />
      <LessonItemTitle section={props.section} />
      <LessonItemDuration section={props.section} />
    </div>
  );
};
